import virtualq from "../Assets/logo/virtualq-neu.jpg";
import remedicare from "../Assets/logo/remedicare_staffing_logo.jpg";
import panaton from "../Assets/logo/panaton_inc__cover.jpg";
import linkDev from "../Assets/logo/images.png";
import dso from "../Assets/logo/images.jpg";

export const partners = [
  { id: 1, name: "virtualQ", logo: virtualq, height: 60 },
  { id: 2, name: "Remedicare", logo: remedicare, height: 60 },
  { id: 3, name: "Panaton", logo: panaton, height: 60 },
  { id: 4, name: "Link Development", logo: linkDev, height: 60 },
  { id: 5, name: "DSOMarketWatch", logo: dso, height: 60 },
];